"use client";

import { useEffect } from "react";
import { endNativePaymentNavigation } from "@/lib/native/payment-navigation";

/**
 * Releases a payment-navigation lease after any full-document return.
 *
 * Razorpay redirect mode destroys the page that called `begin()`, so that
 * page's `finally` cannot close the native lease. The return route can then
 * server-redirect again (for example, an already-paid membership goes straight
 * to the wallet), which means cleanup cannot belong to one payment screen. The
 * root landing is the first reliable client code shared by every destination.
 */
export function NativePaymentNavigationReset() {
  useEffect(() => {
    void endNativePaymentNavigation();
  }, []);

  return null;
}
